module.exports = __webpack_public_path__ + "img/blurmap-VARILUX-PHYSIO_full_white.2ce26466.png";